// extracted by mini-css-extract-plugin
export var contrastLow = "_3x-1";
export var externalLink = "_3x-2";
export var externalLinkIcon = "_3x-3";
export var link = "_3x-0";
export var linkLabel = "_3x-4";